/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualDigestMultibase: core.serialization.ObjectSchema<
    serializers.NotEqualDigestMultibase.Raw,
    Truvity.NotEqualDigestMultibase
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualDigestMultibase {
    export interface Raw {
        value: string;
    }
}
